<template>
  <v-container class="pa-0">
    <v-row align="center" justify="center" :style="contentsHeight">
      <v-col cols="6" class="pa-1">
        <v-toolbar dark flat color="primary" class="rounded-t-xl">
          <v-spacer></v-spacer>
          <v-toolbar-title>問合せ</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card class="pa-1 rounded-b-xl" elevation="0" outlined>
          <v-row align="center" class="ma-0">
            <v-col cols="12" class="py-0" align="end">
              <small>*</small><small class="error--text font-weight-bold caption">必須</small>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="ma-0">
            <v-col cols="12" class="py-0" align="center">
              <v-form ref="form" v-model="rules.valid">
                <v-text-field
                  ref="name"
                  autocomplete="off"
                  prepend-icon="person"
                  v-model="contactForm.name"
                  :rules="[rules.required]"
                  label="*名前"
                  class="pt-0"
                ></v-text-field>
                <v-text-field
                  ref="mail"
                  autocomplete="off"
                  prepend-icon="mail"
                  v-model="contactForm.email"
                  :rules="[rules.required, rules.email]"
                  label="*メールアドレス"
                ></v-text-field>
                <v-text-field
                  ref="emailVerify"
                  autocomplete="off"
                  prepend-icon="mdi-email-check"
                  v-model="contactForm.emailVerify"
                  :rules="[rules.required, rules.emailVerify, rules.email]"
                  label="*メールアドレス（確認）"
                ></v-text-field>
                <v-textarea
                  ref="contents"
                  prepend-inner-icon="mdi-pencil-box"
                  v-model="contactForm.contents"
                  :rules="[rules.required]"
                  label="問合せ内容"
                  outlined
                  rows="10"
                  hide-details
                ></v-textarea>
              </v-form>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="ma-0">
            <v-col cols="12" class="py-0" align="center">
              <v-checkbox
                v-model="pp"
                :rules="[rules.required]"
                color="error"
              >
                <template slot="label">
                  <span class="px-2">*</span>
                  <v-btn small depressed rounded outlined color="error" @click.stop="onTOS()">利用規約</v-btn>
                  <span class="caption">&nbsp;および&nbsp;</span>
                  <v-btn small depressed rounded outlined color="error" @click.stop="onPP()">個人情報保護</v-btn>
                  <span class="caption">&nbsp;に同意します。&nbsp;</span>
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12" class="py-0" align="center">
              <v-btn
                :disabled="!rules.valid || !pp"
                @click="precheck = true"
                depressed
                rounded
                color="primary"
              >送信</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <div>
      <v-dialog v-model="tospp"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
        >
        <app-tos-pp
          @dismissed="onDismissed"
          :dialog='tospp'
          :type='type'
          :close="true"
          >
        </app-tos-pp>
      </v-dialog>
    </div>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title='送信'
        message='問合せを送信します。よろしいですか？'
        :dialog='precheck'
        color="primary"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <v-snackbar
      v-model="snackBar.show"
      :color="snackBar.color"
      top
      :timeout="3000"
      class="font-weight-bold"
    >
      {{snackBar.message}}
    </v-snackbar>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import firebase from 'firebase/app'
import 'firebase/functions'
export default {
  computed: {
    ...mapGetters({
      windowSize: 'shared/windowSize'
    }),
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 40) + 'px;'
    }
  },
  data () {
    return {
      loading: false,
      pp: false,
      tospp: false,
      precheck: false,
      type: null,
      contactForm: {
        name: '',
        contents: '',
        email: '',
        emailVerify: ''
      },
      rules: {
        valid: false,
        emailVerify: v => v === this.contactForm.email || 'メールアドレスが異なっています',
        required: v => !!v || '必須',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || '無効なメールアドレスです'
        }
      },
      snackBar: {
        show: false,
        color: '',
        message: ''
      }
    }
  },
  methods: {
    onDismissed: function (result) {
      this.tospp = false
      if (this.precheck) {
        this.precheck = false
        if (result) {
          this.$nextTick(function () {
            this.sendMail()
          })
        }
      }
    },
    onTOS () {
      this.type = 'tos'
      this.tospp = true
    },
    onPP () {
      this.type = 'pp'
      this.tospp = true
    },
    sendMail: function () {
      var vm = this
      if (this.$refs.form.validate()) {
        this.loading = true
        const functions = firebase.app().functions('asia-northeast1')
        const mailer = functions.httpsCallable('sendMail')
        mailer(this.contactForm)
          .then(() => {
            vm.showSnackBar(
              'success',
              'お問い合わせありがとうございます。送信完了しました'
            )
            const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
            pause(3000).then(() => {
              vm.$nextTick(function () {
                vm.goto(vm, '/')
              })
            })
          })
          .catch(err => {
            if (err) {
              // console.log(err)
              this.showSnackBar(
                'error',
                '送信に失敗しました。時間をおいて再度お試しください'
              )
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    showSnackBar: function (color, message) {
      this.snackBar.message = message
      this.snackBar.color = color
      this.snackBar.show = true
    }
  }
}
</script>

<style>

</style>
